var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutOfBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "#000000",
    viewBox: "0 -21.66 4.608 4.608",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.027908 0 0 .023424 .56452 -19.991)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m21.65 24.62h20.96c3.42 0 6.22 2.79 6.22 6.21v6.22h-27.18zm-14.29 54.94h5.93c1.72 0 3.12-1.42 3.12-3.12v-9.35h-12.18v9.35c0 1.71 1.41 3.12 3.13 3.12zm101.43 0h5.93c1.72 0 3.12-1.42 3.12-3.12v-9.35h-12.18v9.35c0.01 1.71 1.42 3.12 3.13 3.12zm-105.97-38.55h1.41v-37.89c0-1.72 1.41-3.12 3.12-3.12h5.93c1.72 0 3.12 1.4 3.12 3.12v37.89h89.26v-17.87c0-1.72 1.4-3.12 3.12-3.12h5.93c1.72 0 3.12 1.42 3.12 3.12v17.87h2.22c1.55 0 2.82 1.27 2.82 2.82v15.99c0 1.55-1.27 2.81-2.82 2.81h-117.23c-1.55 0-2.82-1.27-2.82-2.81v-15.99c0-1.55 1.27-2.82 2.82-2.82z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfBed);
export default __webpack_public_path__ + "static/media/out-of-bed.fbd747202d1f7506faf6d1edb8608656.svg";
export { ForwardRef as ReactComponent };